import { cn } from '~/lib/cn';

interface HexPatternProps {
  className?: string;
}

/**
 * Tiled hexagon SVG pattern — purely decorative background motif.
 * Draws from the ARPA sygnet hexagon shape at very low opacity (6%).
 * Use absolutely-positioned with `pointer-events-none` to sit behind content.
 */
function HexPattern({ className }: HexPatternProps) {
  // Hexagon path for a 40px-wide hex tile (flat-top orientation)
  // Grid: 40px column, 46px row (staggered offset on even columns)
  const hexPath = 'M20,2 L38,11 L38,29 L20,38 L2,29 L2,11 Z';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn('pointer-events-none select-none', className)}
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        <pattern id="hex-pattern" x="0" y="0" width="60" height="52" patternUnits="userSpaceOnUse">
          {/* Primary hex tile */}
          <path d={hexPath} fill="none" stroke="#00C8FF" strokeWidth="1" opacity="0.06" />
          {/* Offset tile for grid stagger */}
          <path
            d={hexPath}
            transform="translate(30, 26)"
            fill="none"
            stroke="#00C8FF"
            strokeWidth="1"
            opacity="0.06"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#hex-pattern)" />
    </svg>
  );
}

export { HexPattern };
export type { HexPatternProps };
export default HexPattern;
